import { useMediaQuery, useTheme } from '@mui/material';

/** Matches MUI `theme.breakpoints.down('md')` — phones and portrait tablets. */
export function useCompactLayout(): boolean {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('md'), { noSsr: true });
}

/** Matches MUI `theme.breakpoints.down('sm')` — phones only. */
export function usePhoneLayout(): boolean {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true });
}
